/**
Project: Voice Panel (c)
Title: Alert Success Message
Description: Component for displaying the success message as alert
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import { Text, Alert, AcceptIcon } from "@fluentui/react-northstar";

const AlertSuccessMessage = ({ content, fitted = true }) => {
  return (
    <Alert
      success
      fitted={fitted}
      icon={
        <AcceptIcon
          circular
          className="page-alert-success-icon"
        />}
      className="page-alert-success"
      content={
        <Text className="page-alert-success-text">{content}</Text>
      }
    ></Alert>
  );
};

export default AlertSuccessMessage;
